import { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitleDefault from '../default/DialogTitleDefault';
import {
    Box,
    Divider,
    Grid,
    TextField,
    Typography,
    useTheme,
} from '@mui/material';
import { toast } from 'react-toastify';
import { ButtonBasic, InputSearchDireccionEntrega } from '../../components';
import NotifyBajaDAService from '../../services/notifyBajaDA.service';

const fieldSx = (isDarkMode) => ({
    '& .MuiInputBase-input': { color: isDarkMode ? '#e0e0e0' : '#111' },
    '& .MuiInputLabel-root': { color: isDarkMode ? '#9aa8be' : '#555' },
    '& .MuiOutlinedInput-root': {
        color: isDarkMode ? '#e0e0e0' : '#111',
        '& fieldset': {
            borderColor: isDarkMode ? '#3d4a62' : '#c4c4c4',
        },
        '&:hover fieldset': {
            borderColor: isDarkMode ? '#4d5e7a' : '#9e9e9e',
        },
        '&.Mui-focused fieldset': {
            borderColor: isDarkMode ? '#90caf9' : '#0364ff',
        },
    },
});

const ModalRechazoDARegistro = ({ show, hideModal, keyGroup, item, mode = 'create', onSaved }) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const isEdit = mode === 'edit';

    const [form, setForm] = useState({
        contrato: item?.contratoId_nbda || '',
        cuenta: item?.cuentaId_nbda || '',
        nombre: item?.nombre_nbda || '',
        email: item?.email_nbda || '',
        motivo: item?.motivo_nbda || '',
    });
    const [errors, setErrors] = useState({});
    const [isSaving, setIsSaving] = useState(false);

    const handleClose = () => hideModal();

    const onChange = (field, value) => {
        setForm((prev) => ({ ...prev, [field]: value }));
        if (errors[field]) setErrors((prev) => ({ ...prev, [field]: false }));
    };

    const validar = () => {
        const e = {};
        if (!form.contrato.trim()) e.contrato = true;
        if (!form.motivo.trim()) e.motivo = true;
        setErrors(e);
        return Object.keys(e).length === 0;
    };

    const onGuardar = async () => {
        if (!validar()) {
            toast.error('Completá los campos obligatorios.');
            return;
        }
        setIsSaving(true);
        try {
            if (isEdit) {
                await NotifyBajaDAService.updateRegistro(item.id_nbda, form);
                toast.success('Registro actualizado');
            } else {
                await NotifyBajaDAService.createRegistro({ ...form, keyGroup });
                toast.success('Registro agregado');
            }
            if (onSaved) onSaved();
            handleClose();
        } catch (err) {
            const msg = err?.response?.data?.msg || 'No se pudo guardar el registro.';
            toast.error(msg);
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <Dialog open={show} disableEscapeKeyDown maxWidth='sm' fullWidth>
            <Box sx={{ background: isDarkMode ? '#1F2A40' : '#fff' }}>
                <DialogTitleDefault id='registro-rda' onClose={handleClose}>
                    <Typography sx={{ flex: 1, textAlign: 'center', color: isDarkMode ? '#fff' : '#000', fontWeight: 'bold' }} variant='h5'>
                        {isEdit ? 'Editar registro' : 'Nuevo registro'}
                    </Typography>
                </DialogTitleDefault>
                <Divider sx={{ background: isDarkMode ? '#3d4a62' : 'gray' }} />
                <DialogContent>
                    <Grid container spacing={2} sx={{ mt: 0.5 }}>
                      <Grid item xs={12}>
                          <Typography sx={{ color: isDarkMode ? '#e0e0e0' : '#111', fontSize: 14, mb: 0.5 }}>
                            Servicio
                          </Typography>
                          <InputSearchDireccionEntrega
                            filterService='soft'
                            onClick={(opt)=>{
                              onChange('contrato', opt?.contrato?.trim() || '');
                              onChange('cuenta', opt?.cuenta?.trim() || '');
                              onChange('nombre', opt?.nombre || '');
                              onChange('email', opt?.email?.trim() || '');
                            }}
                          />
                      </Grid>
                      {(form.contrato || form.cuenta || form.nombre || form.email) && (
                        <Grid item xs={12}>
                            <Box sx={{
                                border: errors.contrato ? '1.5px solid #f44336' : `1.5px solid ${isDarkMode ? '#3d4a62' : '#c4c4c4'}`,
                                borderRadius: 2,
                                p: 1.5,
                                background: isDarkMode ? '#162032' : '#f5f7fa',
                            }}>
                                <Grid container spacing={1}>
                                    {form.contrato && (
                                        <Grid item xs={6}>
                                            <Typography sx={{ fontSize: 11, color: isDarkMode ? '#9aa8be' : '#777' }}>Contrato</Typography>
                                            <Typography sx={{ fontSize: 13, fontWeight: 600, color: isDarkMode ? '#e0e0e0' : '#111' }}>{form.contrato}</Typography>
                                        </Grid>
                                    )}
                                    {form.cuenta && (
                                        <Grid item xs={6}>
                                            <Typography sx={{ fontSize: 11, color: isDarkMode ? '#9aa8be' : '#777' }}>Cuenta</Typography>
                                            <Typography sx={{ fontSize: 13, fontWeight: 600, color: isDarkMode ? '#e0e0e0' : '#111' }}>{form.cuenta}</Typography>
                                        </Grid>
                                    )}
                                    {form.nombre && (
                                        <Grid item xs={12}>
                                            <Typography sx={{ fontSize: 11, color: isDarkMode ? '#9aa8be' : '#777' }}>Nombre</Typography>
                                            <Typography sx={{ fontSize: 13, color: isDarkMode ? '#e0e0e0' : '#111' }}>{form.nombre}</Typography>
                                        </Grid>
                                    )}
                                    {form.email && (
                                        <Grid item xs={12}>
                                            <Typography sx={{ fontSize: 11, color: isDarkMode ? '#9aa8be' : '#777' }}>Email</Typography>
                                            <Typography sx={{ fontSize: 13, color: isDarkMode ? '#e0e0e0' : '#111' }}>{form.email}</Typography>
                                        </Grid>
                                    )}
                                </Grid>
                            </Box>
                            {errors.contrato && (
                                <Typography sx={{ fontSize: 11, color: '#f44336', mt: 0.5, ml: 1.5 }}>Seleccioná un servicio</Typography>
                            )}
                        </Grid>
                      )}
                      {!form.contrato && errors.contrato && (
                        <Grid item xs={12}>
                            <Typography sx={{ fontSize: 11, color: '#f44336', ml: 0.5 }}>Seleccioná un servicio</Typography>
                        </Grid>
                      )}
                        <Grid item xs={12}>
                            <TextField
                                label='Motivo *'
                                value={form.motivo}
                                onChange={(e) => onChange('motivo', e.target.value)}
                                error={!!errors.motivo}
                                helperText={errors.motivo ? 'Obligatorio' : ''}
                                size='small'
                                fullWidth
                                multiline
                                minRows={2}
                                sx={fieldSx(isDarkMode)}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <Divider sx={{ background: isDarkMode ? '#3d4a62' : 'gray' }} />
                <DialogActions sx={{ p: 2 }}>
                    <ButtonBasic
                        textButton='Cancelar'
                        variant='outlined'
                        color='inherit'
                        onClick={handleClose}
                        isDisabled={isSaving}
                    />
                    <ButtonBasic
                        textButton={isEdit ? 'Guardar cambios' : 'Agregar'}
                        color='warning'
                        onClick={onGuardar}
                        isLoading={isSaving}
                    />
                </DialogActions>
            </Box>
        </Dialog>
    );
};

export default ModalRechazoDARegistro;
